// extracted by mini-css-extract-plugin
export default {"p_content":"_89d52a8234"};